<template>
	<div class="page">
		<div style=" height: 60px; background-color: #007AFF; position: relative; z-index: 1;">
			<div style="width: 200px;">
				<img v-if="config" :src="config.logo2" style="width: 100%;" />
			</div>
		</div>
		<div class="leftbox">
			<div style="height: 10px;"></div>
			
			<div class="smenubox" style=" border-radius: 6px;">
				<div :class="['menuitem',nowsMenu==item.id?'menuckd':'']" v-for="(item,idx) in Smenus" :key="idx"
					@click="goPage(item)">
					<i :class="item.icon"></i> {{item.title}}
					<div class="ckdtail">
			
					</div>
				</div>
			</div>
		</div>
		<div class="rightmain">
			<router-view />
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				nowsMenu:1,
				Smenus:[
					{id:1,title:"填写信息",icon:"el-icon-edit",path:"/pcbk"},
					{id:2,title:"查看数据",icon:"el-icon-view",path:"/bkview"}
				],
				config:null
			}
		},
		mounted() {
			if(!sessionStorage.getItem("phone")||!sessionStorage.getItem("year")){
				this.$router.push("/xjxx")
			}else{
				this.getSchool()
			}
			
		},
		methods:{
			goPage(e){
				this.nowsMenu = e.id
				this.$router.push(e.path)
			},
			getSchool(){
				this.$http.post("/api/platform_settings",{pmid:window.pmid}).then(res => {
					let config = {
						logo: "",
						leftlogo: "",
						logo2:"",
						mainbg: "",
						schoolname: "",
						loginbg: "",
						favico: ""
					}
					for (let k of res.data) {
				
						switch (k.ktype) {
							case 'logo':
								config.logo = k.kvalue
								break;
							case 'leftlogo':
								config.leftlogo = k.kvalue
								break;
								case 'logo2':
									config.logo2 = k.kvalue
									break;
							case 'mainbg':
								config.mainbg = k.kvalue
								break;
							case 'schoolname':
								config.schoolname = k.kvalue
								document.title="欢迎登陆"+config.schoolname+"招生平台"
								break;
							case 'loginbg':
								config.loginbg = k.kvalue
								break;
							case 'favico':
								config.favico = k.kvalue
								break;
						}
				
					}
					if(config.favico){
						var link = document.createElement('link');
						link.type = 'image/x-icon';
						link.rel = 'shortcut icon';
						link.href = config.favico;
						document.getElementsByTagName('head')[0].appendChild(link);
					}
					this.config = config
					
					
				
				
				})
				
				
			},
		}
	}
</script>

<style scoped>
	.leftbox {
		position: absolute;
		width: 200px;
		height: 100%;
		z-index: 0;
		background-color: #fafbfc;
		box-sizing: border-box;
		top: 0;
		border-top: 60px solid #fff;
	}

	.rightmain {
		margin-left: 200px;
		height: 100%;
		margin-top: -60px;
		box-sizing: border-box;
		border-top: 60px solid #fff;
		background-color: #fafbfc;
	}
	.smenubox {
		width: 160px;
		padding-top: 30px;
		margin: 0 auto;
		background-color: #fff;
		min-height: 85%;
		box-shadow: 2px 2px 6px 2px rgba(24, 144, 255, 0.1);
	}
	
	.menuitem {
		padding: 10px;
		text-align: left;
		cursor: pointer;
		margin: 0 auto;
	
		color: #333333;
	
	}
	
	.menuckd {
	
		color: #1890ff;
		box-shadow: 0 0 6px 2px rgba(24, 144, 255, 0.2) inset;
		border-top-left-radius: 20px;
		border-bottom-left-radius: 20px;
		transform: translateX(10px);
		position: relative;
		background-color: #fafbfc;
	}
	
	.menuckd .ckdtail {
		width: 40px;
		height: 80px;
		position: absolute;
		top: -20px;
		right: -5px;
		background-image: url(../../../../public/images/tail.png);
		background-size: auto 100%;
	
		background-repeat: no-repeat;
		background-color: #fafbfc;
	
	
	
	}
	
</style>
<style type="text/css">
	.cpage{ padding: 20px; height: 100%; box-sizing: border-box;}
</style>
